import { render } from "./PromptControl.vue?vue&type=template&id=43241641"
import script from "./PromptControl.vue?vue&type=script&lang=js"
export * from "./PromptControl.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\voting2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__